/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Enteremailprefix2Inputs */

const zh_danger_enteremailprefix2 = /** @type {(inputs: Danger_Enteremailprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的邮箱`)
};

const en_danger_enteremailprefix2 = /** @type {(inputs: Danger_Enteremailprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your email`)
};

const es_danger_enteremailprefix2 = /** @type {(inputs: Danger_Enteremailprefix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu correo`)
};

/**
* | output |
* | --- |
* | "Please enter your email" |
*
* @param {Danger_Enteremailprefix2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_enteremailprefix2 = /** @type {((inputs?: Danger_Enteremailprefix2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Enteremailprefix2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_enteremailprefix2(inputs)
	if (locale === "en") return en_danger_enteremailprefix2(inputs)
	return es_danger_enteremailprefix2(inputs)
});
export { danger_enteremailprefix2 as "danger_enterEmailPrefix" }